import { useProject } from '../use-project.query';
import { projectIdState } from '../../project.state';
import { useAtomValue } from 'jotai';

export const useProjectTags = () => {
  const projectId = useAtomValue(projectIdState);
  const { data: project } = useProject(projectId);

  return project ? project.tags : [];
};
